import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.theseus.edu.gr";
const DEFAULT_IMAGE = `${SITE_URL}/theseus.png`;

export default function Seo({
  title = "ΚΔΒΜ2 ΘΗΣΕΑΣ",
  description = "Εκπαιδευτικά προγράμματα, voucher ΔΥΠΑ, πιστοποιήσεις και επαγγελματική κατάρτιση από το ΚΔΒΜ2 ΘΗΣΕΑΣ.",
  keywords = "ΚΔΒΜ2, ΘΗΣΕΑΣ, voucher ΔΥΠΑ, κατάρτιση, σεμινάρια, πιστοποίηση",
  image = DEFAULT_IMAGE,
  url = SITE_URL,
  type = "website",
  structuredData,
  noindex = false,
}) {
  const finalImage = image?.startsWith("http")
    ? image
    : `${SITE_URL}${image || "/theseus.png"}`;

  const schemaArray = Array.isArray(structuredData)
    ? structuredData
    : structuredData
    ? [structuredData]
    : [];

  return (
    <Helmet>
      <html lang="el" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow"} />
      <link rel="canonical" href={url} />

      <meta property="og:locale" content="el_GR" />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="ΚΔΒΜ2 ΘΗΣΕΑΣ" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={finalImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={finalImage} />

      {schemaArray.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}